import User from '@spa/apps/trustup-pro-base-js/models/User';
   
class TrustUpPro
{

    constructor({app, apiVersion = '1', url = 'https://www.trustup.pro'} = {})
    {
        this.app = app;
        this.user = null;
        this.apps = null;
        this.token = null;
        this.url = url;
        this.apiVersion = apiVersion;
        // this.auth_api = new TrustupProAuth;
        this.data = {};
    }

    logout()
    {
        return new Promise(function(resolve, reject) {
            window.location.href = window.url.auth+'/logout';
            resolve();
        });
    }

    async request(path, method = 'GET', data = {})
    {
        let parameters = {
            method: method,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        };

        if ( method !== 'GET' ) {
            parameters.body = JSON.stringify(data);
        }

        return fetch(`${this.url}/api/${path}`, parameters).then(response => response.json());
    }

    async getUsers()
    {
        let {users} = await this.request(`professionals/${this.getUser().default_professional.id}/users`);
        return users.map(user => new User(user));
    }

    getUser()
    {
        return window.App.$spa.user;
    }

    getApps()
    {
        return window.App.$spa.apps;
    }

    getApp(key)
    {
        return this.getApps().find(app => app.key == key);
    }

    hasAccount(key)
    {
        let accounts = this.getAccounts(key);
        return accounts && accounts.length > 0;
    }

    getAccounts(key)
    {
        let app = this.getApp(key);
        return app ? app.accounts : null;
    }

    getAccount(key)
    {
        let accounts = this.getAccounts(key);
        return accounts ? accounts[0] : null;
    }

    getAccountUuid(key)
    {
        let account = this.getAccount(key);
        return account ? account.uuid : null;
    }

    async getQuotes({status = '', query = '', archived = 'not'} = {})
    {
        let {documents} = await this.request(`invoicing/quotes?account=${this.getAccountUuid('invoicing')}&query=${query}&status=${status}&archived=${archived}`);
        return documents;
    }

    async getQuote(uuid)
    {
        let {document} = await this.request(`invoicing/quotes/${uuid}?account=${this.getAccountUuid('invoicing')}`, 'GET');
        return document;
    }

    async getInvoices({status = '', query = '', archived = 'not'} = {})
    {
        let {documents} = await this.request(`invoicing/invoices?account=${this.getAccountUuid('invoicing')}&query=${query}&status=${status}&archived=${archived}`);
        return documents;
    }

    async getInvoicingVATOptions(force = false)
    {
        if ( ! force && this.data.invoicing && this.data.invoicing.vat_options ) {
            return this.data.invoicing.vat_options;
        }

        let {vat_options} = await this.request(`invoicing/vat-options?account=${this.getAccountUuid('invoicing')}`);
        this.data.invoicing = {...this.data.invoicing, ...{vat_options}};

        return  this.data.invoicing.vat_options;
    }

    async getInvoicingPriceTypes(force = false)
    {
        if ( ! force && this.data.invoicing && this.data.invoicing.price_types ) {
            return this.data.invoicing.price_types;
        }

        let {price_types} = await this.request(`invoicing/price-types?account=${this.getAccountUuid('invoicing')}`);
        this.data.invoicing = {...this.data.invoicing, ...{price_types}};

        return this.data.invoicing.price_types;
    }

    async storeInvoice(data)
    {
        data.app = 'timetracker';
        let {document} = await this.request(`invoicing/invoices?account=${this.getAccountUuid('invoicing')}`, 'POST', data);
        return document;
    }

    async storeQuote(data)
    {
        let {document} = await this.request(`invoicing/quotes?account=${this.getAccountUuid('invoicing')}`, 'POST', data);
        return document;
    }

    async addItemsToInvoice(invoice, items)
    {
        let {document} = await this.request(`invoicing/invoices/${invoice}/add-items?account=${this.getAccountUuid('invoicing')}`, 'POST', {items: items});
        return document;
    }

    async getReceipts({status = '', type = ''} = {})
    {
        let {receipts} = await this.request(`invoicing/receipts?account=${this.getAccountUuid('invoicing')}&type=${type}&status=${status}`);
        return receipts;
    }
}

const trustup_pro = new TrustUpPro({
    app: process.env.MIX_TRUSTUP_APP_KEY,
    url: process.env.MIX_TRUSTUP_AUTH_URL
});

export { trustup_pro };

export default TrustUpPro;